import router from "@/router";
import { useStore } from "@/store";
import { setToken, getToken } from "@/utils/cookies";
import merge from 'webpack-merge';
import { UserActionTypes } from "@/store/modules/user/action-types";

//打开新窗口
export function openNewWindow(href: string){
  const newTab = window.open() as Window
  newTab.location.href = href
  return newTab;
}
// 数组随机
export function shuffle(arr: any) {
  let len = arr.length;
  for (let i = 0; i < len - 1; i++) {
    var index = Math.floor(Math.random() * (len - i));
    var temp = arr[index];
    arr[index] = arr[len - i - 1];
    arr[len - i - 1] = temp;
  }
  return arr;
}
//判断谷歌浏览器版本
export function getChromeVersion() {
  var arr = navigator.userAgent.split(' ');
  var chromeVersion = '';
  for(var i=0;i < arr.length;i++){
      if(/chrome/i.test(arr[i]))
      chromeVersion = arr[i]
  }
  if(chromeVersion){
      return Number(chromeVersion.split('/')[1].split('.')[0]);
  } else {
      return false;
  }
}

//判断是不是课堂派的主域名，不是个性化域名
export function isKtpSelfDoamin() {
  let secondDomain = getsecondDomain();
    if(location.hostname.includes('ketangpai.com') || location.hostname.includes('ketangpai.cn')) {
      if(secondDomain == null || secondDomain=="" || secondDomain == "www" || secondDomain == "prepc" 
      || secondDomain == "ktp1" || secondDomain == "ktp2" || secondDomain == "ktp3" || secondDomain == "ktp4"
      || secondDomain == "v5" || secondDomain == "dev-meeting-lunwen" || secondDomain == "dev-web-portal"
      || secondDomain == "pc.webtest" || secondDomain == "webtest" || secondDomain == "pc" ||  secondDomain == "jigou") {
      return true;
    }
  }
  return false;
}

//获取二级域名
export function getsecondDomain() {
  let href = location.href;
  let secondDomainWithProtocal = href.split(".")[0];
  let secondDomain = secondDomainWithProtocal.split("//")[1];
  return secondDomain;
}

export function toDouble(n: number) {
  if (n < 10) {
    return '0' + n;
  } else {
    return '' + n;
  }
}

//转为1位数
export function toSingle(n: number) {
  return n < 10 ? Number(n) : n;
};

//是否是付费机构
export function isPayVip(){
  let isVip = useStore().state.user.userInfo.schooleinfo.isVip;
  let userInfo = useStore().state.user.userInfo.userinfo;
  let whiteLists:any = ["hi@ketangpai.com"];//特殊账号的处理 "hi@ketangpai.com"
  if(isVip == 0){
    for(let i=0;i<whiteLists.length;i++){
      if(whiteLists[i] == userInfo.email){
        return true;
      }
    }
    return false;
  }
  return true;
}

//参数URL里面的参数
export function delUrlQuery(url: string, paramKey: string) {
  let beforeUrl = url.substr(0, url.indexOf("?"));   //?之前主地址
  let afterUrl = url.substr(url.indexOf("?") + 1);   //？之后参数路径
  let nextUrl = "";
  let arr = new Array();
  if (afterUrl != "") {
    let urlParamArr = afterUrl.split("&"); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = "?" + arr.join("&");
  }
  url = beforeUrl + nextUrl;
  return url;
}

//改变url里面的参数
export function changeURLArg(url: string, arg: any, arg_val: any) {
  let pattern = arg + '=([^&]*)';
  let replaceText = arg + '=' + arg_val;
  if (url.match(pattern)) {
    let tmp = '/(' + arg + '=)([^&]*)/gi';
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match('[\?]')) {
      return url + '&' + replaceText;
    } else {
      return url + '?' + replaceText;
    }
  }
  return url + '\n' + arg + '\n' + arg_val;
}

//设置url的参数
export function setUrlQuery(key: string, name: string) {
  let oldUrl = location.href;
  let nUrl = "";
  if (name == null || name == "" || name.length == 0) {
    nUrl = delUrlQuery(oldUrl, key);
  } else {
    nUrl = changeURLArg(oldUrl, key, name);
  }
  let state = { title: '', url: nUrl };
  window.history.replaceState(state, '', nUrl);
  router.push({
    query:merge({},{'xktptoken':''})
  });
}

//获取URL链接里面的参数
export function getUrlQuery(name: string) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

//获取URL链接里面的参数，处理hash模式
export function getUrlQueryUseHash(paraName: string,locationHref:string="") {
  let url = document.location.toString();
  if(locationHref && locationHref.length>0){
    url = locationHref;
  }
  let arrObj = url.split("?");
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return null;
  }
  else {
    return null;
  }
}

//通过参数里面的token来进行登录
export function usePathTokenTologin() {
  //判断路由地址
  const urlCache = window.location.href;
  if (urlCache != null && (urlCache.indexOf("/login") >= 0)) {
    let xtoken = getUrlQueryUseHash('xktptoken');
    //通过外部传进来的token值，要进行处理
    if (xtoken != null && xtoken.length > 0) {
      setToken(xtoken);
      setUrlQuery('xktptoken', "");
      //直接请求用户信息
      useStore().dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined);
      setTimeout(() => {
        router.push({ path: "/home" });
      }, 1500);
      return true;
    }
    let expiredx = getUrlQueryUseHash('expiredx');
    if (expiredx != null && expiredx.length > 0) {
      setToken(expiredx);
      setUrlQuery('expiredx', "");
      //直接请求用户信息
      useStore().dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined);
      setTimeout(() => {
        router.push({ path: "/home" });
      }, 1500);
      return true;
    }
  }
  return false;
}

//跳转到老师的统计页面
export function gotoTeacherManageDetail(teacherId:string) {
  if(teacherId == null || teacherId == undefined || teacherId == ""){
    return;
  }
  let url:string = "/#/academicAffairs/TeacherManageEduc/teacherManageDetail?id="+teacherId;
  openNewWindow(url);
}

//跳转到学生的统计页面
export function gotoStudentManageDetail(studentId:string) {
  if(studentId == null || studentId == undefined || studentId == ""){
    return;
  }
  let url:string = "/#/academicAffairs/studentManageEduc/StudentManageDetail?id="+studentId;
  openNewWindow(url);
}

//获取学期名称
export function getTermName(term:any){
  return term ==='0'? "全年":(term ==='1'?"第一学期":"第二学期");
}